import StandardQueryTable from "@/components/StandardQueryTable";
import { PATH_DICTS_SHIFT_REPORT_DEPARTMENTS } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { defaultDictionaryTableFeatures } from "@/containers/dictionaries/defaultDictionaryTableFeatures";
import { Module } from "@/constants";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import ShiftReportDepartmentCreator from "@/modules/shiftReportDepartments/components/ShiftReportDepartmentCreator";
import ShiftReportDepartmentEditor from "@/modules/shiftReportDepartments/components/ShiftReportDepartmentEditor";
import { ShiftReportDepartmentsService } from "@/modules/shiftReportDepartments/service";
import {
  readShiftReportDepartment,
  writeShiftReportDepartment,
} from "@/schemas/shiftReportDepartment";
import {
  ReadShiftReportDepartment,
  WriteShiftReportDepartment,
} from "@/types/shiftReportDepartment";
import { ClipboardList } from "lucide-react";

const id = Module.ShiftReportDepartments;
const path = PATH_DICTS_SHIFT_REPORT_DEPARTMENTS;
const ns = "shiftReportDepartments";

const config: DictionaryConfig<
  ReadShiftReportDepartment,
  WriteShiftReportDepartment
> = {
  id,
  ns,
  service: ShiftReportDepartmentsService,
  path,
  labels: createDictionaryLabels(ns),
  getLabels: getDictionaryLabels,
  schema: writeShiftReportDepartment,
  defaultValues: {
    name: "",
    description: "",
  },
  Icon: ClipboardList,
  List: () => (
    <StandardQueryTable<ReadShiftReportDepartment>
      schema={readShiftReportDepartment}
      name={ns}
      fetchList={ShiftReportDepartmentsService.getList}
      pathBuilder={(row) => `${path}/${row.id}`}
      tableFeatures={{
        ...defaultDictionaryTableFeatures,
        exportSettings: { moduleName: Module.ShiftReportDepartments },
      }}
    />
  ),
  Creator: ShiftReportDepartmentCreator,
  Editor: ShiftReportDepartmentEditor,
};

export default config;
